import gql from 'graphql-tag'
import { FetchResult } from '@apollo/client'
import { CartId } from 'lib/types'
import { apolloClient } from 'lib/core/services/magento/client'
import { PAYMENT_METHOD } from 'lib/core/resources/constants'
import { SetPaymentMethodOnCartResponse } from './types'

export type CreateFree = (params: {
  cartId: CartId
  lockCheckout: () => void
  unlockCheckout: () => void
}) => () => Promise<string>

export const createFreePaymentMethod: CreateFree = ({
  cartId,
  lockCheckout,
  unlockCheckout
}) => async () => {
  if (!cartId) {
    await Promise.reject(new Error('cartId is undefined'))
  }

  const mutation = async (): Promise<FetchResult<SetPaymentMethodOnCartResponse>> => {
    const query = `
      mutation {
        setPaymentMethodOnCart (
          input: {
            cart_id: "${cartId}",
            payment_method: {
              code: "${PAYMENT_METHOD.FREE}"
            }
          }
        ) {
          cart {
            selected_payment_method {
              code
            }
          }
        }
      }
    `
    return apolloClient.mutate({ mutation: gql`${query}` })
  }

  lockCheckout()
  try {
    const response = await mutation()
    const code = response.data?.setPaymentMethodOnCart.cart.selected_payment_method.code
    if (!code) {
      throw new Error()
    }

    unlockCheckout()
    return code
  } catch (e) {
    unlockCheckout()
    throw e
  }
}
